export default __webpack_public_path__ + "assets/custom-check-component.3805e4cd.svg";